interface MenuNavigation {
  expandable: boolean;
  name: string;
  route?: string;
  level: number;
  icon?: string;
  materialIcon?: string;
  activeRoutes?: string[];
  isExpanded?: boolean;
  active?: boolean;
  status?: string;
  mobile: boolean;
}

const NAVIGATION_STRUCTURE: MenuNavigation[] = [
  {
    name: 'Dashboard',
    route: 'dashboard',
    expandable: false,
    level: 0,
    icon: 'dashboard',
    active: true,
    status: 'view dashboard',
    mobile: true
  },
  {
    name: 'Search',
    route: 'search',
    expandable: false,
    level: 0,
    materialIcon: 'search',
    status: 'find anything',
    mobile: true,
  },
  {
    name: 'Operations',
    expandable: true,
    level: 0,
    icon: 'sales',
    isExpanded: true,
    mobile: true,
  },
  {
    name: 'Tasks',
    route: 'tasks',
    expandable: false,
    level: 1,
    status: '',
    mobile: true,
  },
  {
    name: 'Calendar',
    route: 'calendar',
    expandable: false,
    level: 1,
    status: 'running list of upcoming items',
    mobile: true,
  },
  {
    name: 'Website Enquiries',
    route: 'website-enquiries',
    expandable: false,
    level: 1,
    status: 'review website enquiries',
    mobile: true,
  },
  {
    name: 'Sales',
    expandable: true,
    level: 0,
    icon: 'reports',
    mobile: false
  },
  {
    name: 'Customers',
    route: 'customers',
    expandable: false,
    level: 1,
    mobile: false,
  },
  {
    name: 'Invoices',
    route: 'invoices',
    expandable: false,
    level: 1,
    status: 'view, create and manage invoices',
    mobile: false,
  },
  {
    name: 'Inventory',
    expandable: true,
    level: 0,
    icon: 'purchases',
    mobile: false,
  },
  {
    name: 'Inventory',
    route: 'inventory',
    expandable: false,
    level: 1,
    mobile: false,
  },
  {
    name: 'Parts Ordered',
    route: 'books/parts-ordered',
    expandable: false,
    level: 1,
    mobile: false,
  },
  {
    name: 'Finance',
    expandable: true,
    level: 0,
    icon: 'accounting',
    mobile: false,
  },
  {
    name: 'Bookkeeping',
    route: 'books/overview',
    activeRoutes: ['books'],
    expandable: false,
    level: 1,
    mobile: false,
  },
  {
    name: 'Transactions',
    route: 'transactions',
    expandable: false,
    level: 1,
    mobile: false,
  },
  {
    name: 'Accounts',
    route: 'accounts',
    expandable: false,
    level: 1,
    mobile: false,
  },
  {
    name: 'Receipts',
    route: 'books/receipts',
    expandable: false,
    level: 1,
    mobile: false,
  },
  {
    name: 'Pending Revenue',
    route: 'pending-revenue-old',
    expandable: false,
    level: 1,
    mobile: false,
  },
  {
    name: 'Square reconciliation',
    route: 'books/square-reconciliation',
    expandable: false,
    level: 1,
    status: 'Square deposits in Pending Revenue',
    mobile: false,
  },

  {
    name: 'Cash reconciliation',
    route: 'books/cash-reconciliation',
    expandable: false,
    level: 1,
    status: 'Apost cash deposits in Pending Revenue',
    mobile: false,
  },
  {
    name: 'Weekly Report',
    route: 'weekly-report',
    expandable: false,
    level: 1,
    status: 'weekly business summary',
    mobile: false,
  },
  {
    name: 'Tools',
    expandable: true,
    level: 0,
    icon: 'reports',
    mobile: false
  },
  {
    name: 'Music',
    route: 'music',
    expandable: false,
    level: 1,
    status: 'music library and player',
    mobile: false,
  },
  {
    name: 'Remote',
    route: 'remote',
    expandable: false,
    level: 1,
    mobile: false,
  },
  {
    name: 'Automation',
    route: 'automation',
    expandable: false,
    level: 1,
    mobile: false,
  },
  {
    name: 'Socials',
    route: 'socials',
    expandable: false,
    level: 1,
    mobile: false,
  },
  {
    name: 'System',
    expandable: true,
    level: 0,
    icon: 'settings',
    mobile: true
  },
  {
    name: 'Settings',
    route: 'settings',
    expandable: false,
    level: 1,
    mobile: true,
  },
  {
    name: 'Tests',
    route: 'tests',
    expandable: false,
    level: 1,
    mobile: false,
  }
];

export { NAVIGATION_STRUCTURE, MenuNavigation }
